// ChatComponent.js

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import styled from 'styled-components';

import Markdown from 'react-markdown';
import Service from '../services/applicationService';

const ChatContainer = styled.div`
  max-width: 70%;
  margin: auto;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
`;

const MessageContainer = styled.div`
  margin-bottom: 10px;
`;

const InputContainer = styled.div`
  display: flex;
  margin-top: 20px;

  input {
    flex: 1;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
  }

  button {
    background-color: #006AE6;
    color: #fff;
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
`;

const MAX_TOKENS = 4000;

const truncateMessages = (messages) => {
    let tokenCount = 0;
    const truncated = [];
    for (let i = messages.length - 1; i >= 0; i--) {
        const messageTokens = messages[i].content.split(" ").length;
        if (tokenCount + messageTokens > MAX_TOKENS) break;
        truncated.unshift(messages[i]);
        tokenCount += messageTokens;
    }
    return truncated;
};

const ChatComponent = () => {
    const [chat, setChat] = useState(false);
    const [enableChatSetting, setChatSetting] = useState(-1);
    const [display, setDisplay] = useState('none');
    const [input, setInput] = useState('');
    const [messages, setMessages] = useState([]);
    const [showChat, setShowChat] = useState(false);
    var status = -1;

    const adjustViewPort = () => {
        var content = document.getElementById('container-message');
        if (content == null) return;
        content.scrollTop = content.scrollHeight;
    }

    const nudgeViewPort = (amount) => {
        var content = document.getElementById('chatContainer');
        content.scrollBy(0, amount);
    }

    const adjustWindow = () => {
        window.scrollTo(0, document.body.scrollHeight);
    }

    const handleShowChat = () => {
        const el = document.getElementById("chatContainer");
        const ol = document.getElementById("container-chat");
        const il = document.getElementById("chatTrigger");
        if (chat === true) {
            setChat(false);
            setDisplay('none');
            el.classList.add('hide-chat');
            ol.classList.add('hide-chat');
            il.classList.remove('hide-button');
        } else if (chat === false) {
            setChat(true);
            setDisplay('block');
            el.classList.remove('hide-chat');
            ol.classList.remove('hide-chat');
            il.classList.add('hide-button');
        }

        const chatGPTWelcome = {
            content: 'Please ask your questions about eCPS portal.',
            role: 'assistant',
        };

        if (messages.length === 0) {
            setMessages((prevMessages) => [chatGPTWelcome]);
        } else {
            setMessages((prevMessages) => [...prevMessages]);
        }
    }

    const handleMinimizeChat = () => {
        const el = document.getElementById("chatContainer");
        const ol = document.getElementById("container-chat");
        const il = document.getElementById("chatTrigger");
        if (chat === true) {
            setChat(false);
            setDisplay('none');
            el.classList.add('hide-chat');
            ol.classList.add('hide-chat');
            il.classList.remove('hide-button');
        } else if (chat === false) {
            setChat(true);
            setDisplay('block');
            el.classList.remove('hide-chat');
            ol.classList.remove('hide-chat');
            il.classList.add('hide-button');
        }
        setMessages((prevMessages) => [...prevMessages]);
    }

    const handleCloseChat = () => {
        const el = document.getElementById("chatContainer");
        const ol = document.getElementById("container-chat");
        const il = document.getElementById("chatTrigger");
        if (chat === true) {
            setChat(false);
            setDisplay('none');
            el.classList.add('hide-chat');
            ol.classList.add('hide-chat');
            il.classList.remove('hide-button');
        } else if (chat === false) {
            setChat(true);
            setDisplay('block');
            el.classList.remove('hide-chat');
            ol.classList.remove('hide-chat');
            il.classList.add('hide-button');
        }

        const chatGPTWelcome = {
            content: 'Please ask your questions about eCPS portal.',
            role: 'assistant',
        };
        setMessages((prevMessages) => [chatGPTWelcome]);
    }

    useEffect(() => {
        adjustViewPort();
        getChatSettings();
    }, [messages]);

    const handleInputChange = (e) => {
        setInput(e.target.value);
    };

    const getChatSettings = async () => {
        if (enableChatSetting === -1) {
            var resp = await Service.getAsureChatGptSettings();
            if (resp.status === 200) {
                setChatSetting(200);
                setShowChat(resp.data);
            }
        }
        else {
            setChatSetting('0');
        }
    }

    const showLoading = () => {
        setTimeout(() => {
            //console.log('show loading');
            const parentElement = document.getElementsByClassName('chat-admin')[0];
            const childElement = parentElement.children[0];
            childElement.classList.add('thinking');
        }, 100);
    }

    const hideLoading = () => {
        //console.log('hide loading');
        const parentElement = document.getElementsByClassName('thinking')[0];
        parentElement.classList.remove('thinking');
    }

    const handleSendMessage = async (e) => {

        e.preventDefault();
        const newMessage = {
            content: input,
            role: "user",
        };

        setMessages((prevMessages) => [...prevMessages, newMessage]);

        const chatGPTThinking = {
            content: "Thinking ",
            role: "chat-admin",
        };
        showLoading();
        nudgeViewPort(100);
        setMessages((prevMessages) => [...prevMessages, chatGPTThinking]);

        const proxyUrl = 'api/chat/SendMessage/'; // Update with your API URL

        const body = {
            messages: [
                {
                    role: 'system',
                    content: "You are a helpful assistant tasked with answering user questions based on the FAQ and user manual provided. Your goal is to provide accurate, concise, and clear responses. Do not include any references, citations in your responses under any circumstances."
                },
                ...messages,
                {
                    role: 'user',
                    content: input + ". Answer the question clearly, but do not include any references or citations in your response."
                },
            ],
            stream: true
        };

        body.messages = truncateMessages(body.messages);

        try {
            const response = await fetch(proxyUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });

            const responseStream = await response.body.getReader();

            const decoder = new TextDecoder('utf-8');
            let accumulatedMessage = '';
            let buffer = '';

            hideLoading();

            while (true) {
                const { done, value } = await responseStream.read();

                if (done) break;

                const chunk = decoder.decode(value, { stream: true });

                buffer += chunk;
                const lines = buffer.split('\n').filter(line => line.trim());

                if (!buffer.endsWith('\n')) {

                    buffer = lines.pop() || '';

                } else {
                    buffer = '';
                }

                for (const line of lines) {
                    if (line.trim() === 'data: [DONE]') {
                        console.log('[DONE] - Stream completed');
                        return;
                    }

                    if (line.startsWith('data: ')) {
                        try {
                            const json = JSON.parse(line.substring(6));

                            if (json.choices && json.choices[0]?.delta?.content) {
                                accumulatedMessage += json.choices[0].delta.content;

                                const chatGPTResponse = {
                                    content: accumulatedMessage,
                                    role: 'assistant',
                                };
                                setMessages((prevMessages) => [
                                    ...prevMessages.slice(0, -1),
                                    chatGPTResponse,
                                ]);
                                setInput('');
                            }
                        } catch (error) {
                            console.error('Error parsing JSON:', error);
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Error:', error);
            const chatGPTResponse = {
                content: 'An error occurred while processing the request.',
                role: 'assistant',
            };

            console.log('Exception while processing the request:', chatGPTResponse);
        }
        setInput('');
    };


    if (!showChat) {
        return (<></>);
    }
    return (
        <div className="container-chat hide-chat" id='container-chat'>
            <button className="btn chat-trigger float-trigger" id="chatTrigger" onClick={() => { handleShowChat() }}>
                <div><span>Chat with the eCPS</span>AI Assistant</div>
            </button>
            <div className="overall-chat-container">
                <div className="chat-header"><div>eCPS<span>AI Assistant</span></div>
                    <button type="button" className="close minimize" onClick={() => { handleShowChat() }} aria-label="Minimize">
                        <span aria-hidden="true">&mdash;</span>
                    </button>
                    <button type="button" className="close" onClick={() => { handleCloseChat() }} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form onSubmit={handleSendMessage}>
                    <ChatContainer className='hide-chat' id='chatContainer'>
                        <div id="container-message">
                            {messages.map((message, index) => (
                                <MessageContainer id='messageContainer' key={index} className={message.role} >
                                    <Markdown>{message.content}</Markdown>
                                </MessageContainer>
                            ))}
                        </div>
                        <InputContainer id='inputContainer' >
                            <input type="text" value={input} onChange={handleInputChange} placeholder="Ask a question" />
                            <button type="submit">Send</button>
                        </InputContainer>
                    </ChatContainer>
                </form>
            </div>
        </div>
    );
};

export default ChatComponent;
